import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/app/[locale]/(HOME)/components/hero-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/app/[locale]/(HOME)/components/statistics-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/app/[locale]/(HOME)/components/teachers-section/TeachersGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/app/[locale]/(HOME)/components/testimonial-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/app/[locale]/(HOME)/components/videos-section/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/carousel-img-1.png");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/features-1.jpeg");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/features-2.jpeg");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/features-3.jpeg");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/islamic-logo.png");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/logo.png");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/teacher-1.jpeg");
;
import(/* webpackMode: "eager" */ "/app/apps/hafizalquran/src/assets/images/teacher-2.jpeg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/blocks/components/courses/courses-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/blocks/components/pricing-plan/pricing-plans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/blocks/components/register-section/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_@types+_a6b223a3a93481ef912beb6084c0bd7d/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_@types+_a6b223a3a93481ef912beb6084c0bd7d/node_modules/next/dist/client/image-component.js");
